import { DonutSlice } from './DonutSlice';
import { DonutSliceWithCommands } from './DonutSliceWithCommands';

class CalculusHelper {
  static getSlicesWithCommandsAndOffsets(
    donutSlices: DonutSlice[],
    radius: number,
    svgSize: number,
    borderSize: number,
  ): DonutSliceWithCommands[] {
    let previousPercent = 0;
    return donutSlices.map((slice) => {
      const sliceWithCommands: DonutSliceWithCommands = {
        ...slice,
        commands: CalculusHelper.getSliceCommands(
          slice,
          radius,
          svgSize,
          borderSize,
        ),
        offset: previousPercent * 3.6 * -1,
      };
      previousPercent += slice.percent;
      return sliceWithCommands;
    });
  }

  static getSliceCommands(
    donutSlice: DonutSlice,
    radius: number,
    svgSize: number,
    borderSize: number,
  ): string {
    const degrees = CalculusHelper.percentToDegrees(donutSlice.percent);
    const longPathFlag = degrees > 180 ? 1 : 0;
    const innerRadius = radius - borderSize;

    const commands: string[] = [];
    commands.push(`M ${svgSize / 2 + radius} ${svgSize / 2}`);
    commands.push(
      `A ${radius} ${radius} 0 ${longPathFlag} 0 ${CalculusHelper.getCoordFromDegrees(
        degrees,
        radius,
        svgSize,
      )}`,
    );
    commands.push(
      `L ${CalculusHelper.getCoordFromDegrees(degrees, innerRadius, svgSize)}`,
    );
    commands.push(
      `A ${innerRadius} ${innerRadius} 0 ${longPathFlag} 1 ${
        svgSize / 2 + innerRadius
      } ${svgSize / 2}`,
    );
    return commands.join(' ');
  }

  static getCoordFromDegrees(
    angle: number,
    radius: number,
    svgSize: number,
  ): string {
    const x = Math.cos((angle * Math.PI) / 180);
    const y = Math.sin((angle * Math.PI) / 180);
    const coordX = x * radius + svgSize / 2;
    const coordY = y * -radius + svgSize / 2;
    return [coordX, coordY].join(' ');
  }

  static percentToDegrees(percent: number): number {
    return percent * 3.6;
  }
}

export default CalculusHelper;
